export default {
  plans: (from) => ['plans', from],
  plan: (planId) => ['plan', planId],
  customer: ['customer'],
  upcomingInvoice: ['upcomingInvoice'],
  coupon: (couponId) => ['coupon', couponId],
};
